import PostFeed from '../../../components/PostFeed'

function Feed ({ spaceId }: { spaceId: number }) {
  return (
    <PostFeed spaceId={spaceId} />
  )
}

export default Feed
